import { useMemo } from 'react'
import { useSelectionStore } from '@stores/useSelectionStore'
import { FileExplorerItem } from '@features/file-explorer/types'

interface UseItemSelectionProps {
  item: FileExplorerItem
  getItemKey: (item: FileExplorerItem) => string
}

export function useItemSelection({ item, getItemKey }: UseItemSelectionProps) {
  // Memoize the item key
  const itemKey = useMemo(() => getItemKey(item), [item, getItemKey])

  // Subscribe to this specific item's selection state only
  const isSelected = useSelectionStore(state => state.selectedItems.has(itemKey))

  return { itemKey, isSelected }
}
